export default import.meta.ROLLUP_FILE_URL_vwzsvtDccHFkm_jfK__JdQ